import React from 'react';
import WaiverActions from './WaiverActions';
import { WAIVER_STATUS_ACTIVE, WAIVER_STATUS_CANCELLED, WAIVER_STATUS_PENDING } from '../constants';

interface Waiver {
  id: string;
  status: 'CANCELLED' | 'PENDING' | 'ACTIVE';
  archived: boolean;
}

interface WaiverStatusBoxProps {
  waiver: Waiver;
  readOnly: boolean;
}

class WaiverStatusBox extends React.Component<WaiverStatusBoxProps> {
  getText() {
    return 'Waiver ' + WaiverActions.waiverStatusDescription(this.props.waiver);
  }

  isCancelled() {
    return this.props.waiver.status === WAIVER_STATUS_CANCELLED;
  }

  isPending() {
    return this.props.waiver.status === WAIVER_STATUS_PENDING;
  }

  isActive() {
    return this.props.waiver.status === WAIVER_STATUS_ACTIVE;
  }

  includeWaiverTripSearch() {
    return this.props.readOnly && this.isActive() && !this.props.waiver.archived;
  }

  render() {
    return (
      <div className="waiver-status-container">
        <div className="waiver-status-placeholder"></div>

        {this.includeWaiverTripSearch() ? (
          <a className="waiver-status-box" href={`/trips/search?waiver=${this.props.waiver.id}`}>
            <div className="sprites sprite-bullhorn-ivory-24 status-bullhorn"></div>
            <div className="trip-search-link">View trips associated with this waiver</div>
          </a>
        ) : (
          <div className={`waiver-status-box ${this.isCancelled() ? 'cancelled' : this.isPending() ? 'pending' : ''}`}>
            {this.getText()}
          </div>
        )}
      </div>
    );
  }
}

export default WaiverStatusBox;